import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';
import { UADetect, uaDetectToken } from 'go-modules/detect/ua-detect.service';

@Component({
	selector: 'ios-upload-dialog',
	templateUrl: './ios-upload-dialog.component.html',
	styleUrls: ['./ios-upload-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IosUploadDialogComponent {
	public dialogTitleId = `ios-upload-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	public iosVersion: number;
	public imageLoaded = false;

	constructor (
		public dialogRef: GoDialogRef,
		@Inject(uaDetectToken) public uaDetect: UADetect
	) {
		this.iosVersion = parseInt(this.uaDetect.browserDetector.result.os.version.split('.')[0], 10);
	}

	public close () {
		this.dialogRef.close();
	}
}
